import {DeviceParamLirisV3Trigger} from './device-param-liris-v3-trigger';
import {DeviceParamsLirisV3BoardType} from './device-params-liris-v3-board-type';

export class DeviceParamLiris420 {

  // factory no use :
  public powerMode: number;
  public paramA: number;
  public paramB: number;
  public paramC: number;
  public paramAStretch: number;
  public paramBStretch: number;
  public paramCStretch: number;
  public paramAComp: number;
  public paramBComp: number;
  public paramCComp: number;
  public k1: number;
  public k2: number;
  public k3: number;
  public k4: number;
  public k5: number;
  public k6: number;
  public hysteresis: number;
  public versionHardSensorBoard: number;
  public versionFirmMotherBoard: number;
  public versionFirmSensorBoard: number;
  public versionHardMotherBoard: number;
  public sensorBoardSN: string;
  public extBoardType: string;
  public fabBenchSN: string;
  public assemblyVersion: number;
  public temperature: number;
  public bite: any[];
  public staticRecord: any[];
  public opticLed: any[];
  public infoMb: any[];
  public dateSyncTime: string;
  public sensorBite: any[];
  public opticLedMv: string;
  public infoMbVersion: number;
  public infoSensor: any[];


  // trigger
  public inclinoAxes: number;
  public trigger: DeviceParamLirisV3Trigger = new DeviceParamLirisV3Trigger();

  // can set
  public periodAcq: number;
  public boardType: DeviceParamsLirisV3BoardType = new DeviceParamsLirisV3BoardType();
  public staticRecordPeriod: number;

  public bluetoothName: string;
  public MeasurementMode?: any;

}
